import styled from 'styled-components';
import { SC_BORDER_GRAY } from '../themes/DefaultTheme';

const LineElement = styled.div`
  width: 100%;
  max-width: ${(props: any) => props.maxWidth ?? '100%'};
  background-color: ${SC_BORDER_GRAY};
  height: ${(props: any) => props.height ?? 1}px;
  margin-top: ${(props: any) => getGapTop(props)}px;
  margin-bottom: ${(props: any) => getGapBottom(props)}px;
` as any;

export interface IProps {
  /** Gap above and below the line.  Defaults to 20px */
  gap?: number;
  /** Gap above the line.  Defaults to 20px. */
  gapTop?: number;
  /** Gap below the line.  Defaults to 20px. */
  gapBottom?: number;
  /** Height of the line.  Defaults to 1px. */
  height?: number;
  /** Max width of the line. Defaults to 100% */
  maxWidth?: string;
}

export const Line = (props: IProps) => {
  return <LineElement {...props} data-testid="Line" />;
};

function getGapTop(props) {
  let gap = 20;
  if (props.gap != null) {
    gap = props.gap;
  } else if (props.gapTop != null) {
    gap = props.gapTop;
  }
  return gap;
}

function getGapBottom(props) {
  let gap = 20;
  if (props.gap != null) {
    gap = props.gap;
  } else if (props.gapBottom != null) {
    gap = props.gapBottom;
  }
  return gap;
}
